/**
 * TODO будет перенесено в утилиты и покрыто тестами в https://cianru.atlassian.net/browse/CD-38432
 */
import { getCurrentSlide, normalizeYOffset, getYOffset } from './utils';
import { SliderState, IContainerSize } from '../types';

export function getYOffsetHanlder(state: SliderState, containerSize?: IContainerSize): number {
  const touchOffset = state.action === 'move' ? getYOffset(state) : 0;

  return normalizeYOffset(getCurrentSlide(state), touchOffset + state.offsetCoords.y, containerSize);
}
